var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.56079 20.6516V4.68386C1.56079 2.57876 3.61133 0.86055 6.15405 0.853172C16.2735 0.823782 26.1494 0.949084 36.25 0.887718C36.9507 0.883461 37.5258 1.44542 37.532 2.14614L37.8533 38.6116C37.8565 38.9742 37.5636 39.2699 37.2009 39.2699H10.8943C10.13 39.3811 9.08197 39.4677 7.84814 39.3747C6.63309 39.283 5.63449 39.0468 4.9126 38.8272C3.61148 36.1902 2.22604 32.5739 1.65552 28.1715C1.28589 25.3193 1.34061 22.7732 1.56079 20.6516Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0723 25.2496L19.8108 25.5182L20.0635 25.2408C19.2832 24.4801 18.3115 23.5338 17.5415 22.6578L17.4653 22.5797C16.9561 22.1256 16.4819 21.6002 16.0962 21.1725C15.8755 20.9254 15.6606 20.6891 15.4707 20.5006C16.0674 19.9195 16.8472 19.1754 17.6611 18.399C20.6364 15.5611 22.0794 13.9231 21.9902 13.485L21.7891 12.9176L21.3115 12.8014C20.6475 12.6383 20.2832 13.0162 18.5303 14.8297C17.7158 15.6744 16.7017 16.7252 15.6982 17.6324C15.1831 18.1969 14.5903 18.731 14.1548 19.1236C13.8018 19.4449 13.4985 19.7203 13.2407 20.0162L13.1064 20.2633L13.0586 20.6519L13.0786 21.1978L13.5117 21.4488C13.561 21.4771 13.6123 21.5016 13.665 21.5201L13.8457 21.7144C14.9575 22.9059 16.1655 24.15 17.646 25.6285C18.5845 26.5719 19.5249 27.4723 20.4507 28.356L20.8271 28.7154L21.8306 28.3775L21.9502 27.8961C22.1128 27.2369 21.7612 26.8941 20.0723 25.2496Z",
    fill: "#09366B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevBtn);
export default __webpack_public_path__ + "static/media/prev-btn.a259b8851b71b108c02f2ef4dd63e730.svg";
export { ForwardRef as ReactComponent };